var map = {
	"./apidays-live-hongkong/2021/images/apidays-2021-banner.jpg": "4e32",
	"./apidays-live-hongkong/2021/images/apidays-2021-snapshot-1.jpg": "9196",
	"./apidays-live-hongkong/2021/images/apidays-2021-snapshot-2.jpg": "c4e7",
	"./apidays-live-hongkong/2021/images/apidays-2021-snapshot-3.jpg": "e0fd",
	"./apidays-live-hongkong/2021/images/apidays-2021-snapshot-4.jpg": "9395",
	"./apidays-live-hongkong/2021/images/apidays-2021-snapshot-5.jpg": "9fba",
	"./apidays-live-hongkong/2021/images/apidays-2021-snapshot-6.jpg": "84fb",
	"./apidays-live-hongkong/2021/images/apidays-live-hongkong-2021-agenda-825.png": "5b2d",
	"./apidays-live-hongkong/2021/images/apidays-live-hongkong-2021-agenda-826.png": "9290",
	"./apidays-live-hongkong/2021/images/apidays-live-hongkong-2021-participants.png": "3e92",
	"./apidays-live-hongkong/2021/images/apidays-live-hongkong-2021-video-cover.jpg": "a35f",
	"./apidays-live-hongkong/2021/images/hongkong.jpg": "2aa0",
	"./apidays-live-hongkong/2021/speakers/ajay-pro.jpg": "f0d5",
	"./apidays-live-hongkong/2021/speakers/alanc-pro.jpg": "800c",
	"./apidays-live-hongkong/2021/speakers/alang-pro.jpg": "b310",
	"./apidays-live-hongkong/2021/speakers/andrew-pro.jpg": "16bc",
	"./apidays-live-hongkong/2021/speakers/archana-pro.jpg": "ecf7",
	"./apidays-live-hongkong/2021/speakers/asanka-pro.jpg": "3333",
	"./apidays-live-hongkong/2021/speakers/carl-pro.jpg": "7dfc",
	"./apidays-live-hongkong/2021/speakers/claire-pro.jpg": "15c2",
	"./apidays-live-hongkong/2021/speakers/clive-pro.jpg": "c665",
	"./apidays-live-hongkong/2021/speakers/damir-pro.jpg": "636c",
	"./apidays-live-hongkong/2021/speakers/david-pro.jpg": "bcb9",
	"./apidays-live-hongkong/2021/speakers/default-speaker.jpg": "68b5",
	"./apidays-live-hongkong/2021/speakers/derek-pro.jpg": "4558",
	"./apidays-live-hongkong/2021/speakers/div-pro.jpg": "041d",
	"./apidays-live-hongkong/2021/speakers/eason-pro.jpg": "63b0",
	"./apidays-live-hongkong/2021/speakers/emmelyn-pro.jpg": "1593",
	"./apidays-live-hongkong/2021/speakers/gan-pro.jpg": "1354",
	"./apidays-live-hongkong/2021/speakers/geoffrey-pro.jpg": "ade4",
	"./apidays-live-hongkong/2021/speakers/greg-pro.jpg": "1d8f",
	"./apidays-live-hongkong/2021/speakers/hieu-pro.jpg": "2140",
	"./apidays-live-hongkong/2021/speakers/howard-pro.jpg": "018f",
	"./apidays-live-hongkong/2021/speakers/hugo-pro.jpg": "220e",
	"./apidays-live-hongkong/2021/speakers/isaac-pro.jpg": "3616",
	"./apidays-live-hongkong/2021/speakers/jason-pro.jpg": "1454",
	"./apidays-live-hongkong/2021/speakers/jeffrey-pro.jpg": "e80e",
	"./apidays-live-hongkong/2021/speakers/jenks-pro.jpg": "b545",
	"./apidays-live-hongkong/2021/speakers/jeremy-pro.jpg": "bd34",
	"./apidays-live-hongkong/2021/speakers/jesus-pro.jpg": "7410",
	"./apidays-live-hongkong/2021/speakers/jimmy-pro.jpg": "8fd2",
	"./apidays-live-hongkong/2021/speakers/john-pro.jpg": "172c",
	"./apidays-live-hongkong/2021/speakers/jonathan-pro.jpg": "253f",
	"./apidays-live-hongkong/2021/speakers/kim-pro.jpg": "4b7c",
	"./apidays-live-hongkong/2021/speakers/laurent-pro.jpg": "2f7f",
	"./apidays-live-hongkong/2021/speakers/marco-pro.jpg": "33d9",
	"./apidays-live-hongkong/2021/speakers/marjukka-pro.jpg": "627d",
	"./apidays-live-hongkong/2021/speakers/mathieu-pro.jpg": "0720",
	"./apidays-live-hongkong/2021/speakers/matthias-pro.jpg": "5274",
	"./apidays-live-hongkong/2021/speakers/maxime-pro.jpg": "290c",
	"./apidays-live-hongkong/2021/speakers/maximeb-pro.jpg": "ff2b",
	"./apidays-live-hongkong/2021/speakers/maximet-pro.jpg": "35b6",
	"./apidays-live-hongkong/2021/speakers/mehdi-pro.jpg": "c2ab",
	"./apidays-live-hongkong/2021/speakers/morris-pro.jpg": "b7c8",
	"./apidays-live-hongkong/2021/speakers/naveen-pro.jpg": "41fe",
	"./apidays-live-hongkong/2021/speakers/nicky-pro.jpg": "67c6",
	"./apidays-live-hongkong/2021/speakers/nitin-pro.jpg": "7b52",
	"./apidays-live-hongkong/2021/speakers/patrick-pro.jpg": "9ee6",
	"./apidays-live-hongkong/2021/speakers/phil-pro.jpg": "bc63",
	"./apidays-live-hongkong/2021/speakers/pricilla-pro.jpg": "7d65",
	"./apidays-live-hongkong/2021/speakers/rana-pro.jpg": "3c41",
	"./apidays-live-hongkong/2021/speakers/richard-pro.jpg": "5a4b",
	"./apidays-live-hongkong/2021/speakers/rob-pro.jpg": "5b14",
	"./apidays-live-hongkong/2021/speakers/rosemary-pro.jpg": "7d28",
	"./apidays-live-hongkong/2021/speakers/shahnawaz-pro.jpg": "fdfe",
	"./apidays-live-hongkong/2021/speakers/shiroshica-pro.jpg": "3c1c",
	"./apidays-live-hongkong/2021/speakers/siddhant-pro.jpg": "0e54",
	"./apidays-live-hongkong/2021/speakers/simen-pro.jpg": "8654",
	"./apidays-live-hongkong/2021/speakers/simon-pro.jpg": "df80",
	"./apidays-live-hongkong/2021/speakers/simonw-pro.jpg": "c0b0",
	"./apidays-live-hongkong/2021/speakers/snehal-pro.jpg": "2505",
	"./apidays-live-hongkong/2021/speakers/stuart-pro.jpg": "25e6",
	"./apidays-live-hongkong/2021/speakers/tharika-pro.jpg": "5863",
	"./apidays-live-hongkong/2021/speakers/toa-pro.jpg": "c958",
	"./apidays-live-hongkong/2021/speakers/trevor-pro.jpg": "969b7",
	"./apidays-live-hongkong/2021/speakers/uli-pro.jpg": "33e5",
	"./apidays-live-hongkong/2021/sponsors/amadeus.png": "e23f",
	"./apidays-live-hongkong/2021/sponsors/confluent.png": "37bd",
	"./apidays-live-hongkong/2021/sponsors/hkcs.png": "110d",
	"./apidays-live-hongkong/2021/sponsors/hkstpsaa.png": "454e",
	"./apidays-live-hongkong/2021/sponsors/ibm.png": "0215",
	"./apidays-live-hongkong/2021/sponsors/mulesoft.png": "d993",
	"./apidays-live-hongkong/2021/sponsors/new-relic.png": "d5c5",
	"./apidays-live-hongkong/2021/sponsors/softwareag.png": "d4b6",
	"./apidays-live-hongkong/2022/images/apidays-2022-snapshot-1.jpg": "a03c",
	"./apidays-live-hongkong/2022/images/apidays-2022-snapshot-2.jpg": "53d4",
	"./apidays-live-hongkong/2022/images/apidays-2022-snapshot-charm-1.jpg": "013c",
	"./apidays-live-hongkong/2022/images/apidays-2022-snapshot-gary-1.jpg": "ace2",
	"./apidays-live-hongkong/2022/images/apidays-2022-snapshot-richard-1.jpg": "6f89",
	"./apidays-live-hongkong/2022/images/apidays-2022-snapshot-trevor-1.jpg": "d21d",
	"./apidays-live-hongkong/2022/images/apidays-hongkong-2022-agenda-0824.png": "72f9",
	"./apidays-live-hongkong/2022/images/apidays-hongkong-2022-agenda-0825.png": "0259",
	"./apidays-live-hongkong/2022/images/apidays-hongkong-2022-logo.png": "e9b8",
	"./apidays-live-hongkong/2022/images/apidays-hongkong-2022-participants.jpg": "66f1",
	"./apidays-live-hongkong/2022/images/apidays-hongkong-2022-video-cover.jpg": "8921",
	"./apidays-live-hongkong/2022/speakers/alvin-pro.jpg": "2230",
	"./apidays-live-hongkong/2022/speakers/bob-pro.jpg": "10dc",
	"./apidays-live-hongkong/2022/speakers/brad-pro.jpg": "cb1f",
	"./apidays-live-hongkong/2022/speakers/christine-pro.jpg": "6941",
	"./apidays-live-hongkong/2022/speakers/clive-pro.jpg": "8193",
	"./apidays-live-hongkong/2022/speakers/dale-pro.jpg": "e9b7",
	"./apidays-live-hongkong/2022/speakers/default-speaker.jpg": "b082",
	"./apidays-live-hongkong/2022/speakers/derric-pro.jpg": "39c1",
	"./apidays-live-hongkong/2022/speakers/developersteve-pro.jpg": "67a7",
	"./apidays-live-hongkong/2022/speakers/eason-pro.jpg": "5a54",
	"./apidays-live-hongkong/2022/speakers/enrique-pro.jpg": "521d",
	"./apidays-live-hongkong/2022/speakers/frederic-pro.jpg": "cfae",
	"./apidays-live-hongkong/2022/speakers/gary-pro.jpg": "83c8",
	"./apidays-live-hongkong/2022/speakers/garyl-pro.jpg": "3789",
	"./apidays-live-hongkong/2022/speakers/giovanni-pro.jpg": "be94",
	"./apidays-live-hongkong/2022/speakers/giri-pro.jpg": "9aac",
	"./apidays-live-hongkong/2022/speakers/issac-pro.jpg": "089c",
	"./apidays-live-hongkong/2022/speakers/jeffrey-pro.jpg": "a613",
	"./apidays-live-hongkong/2022/speakers/jeremy-pro.jpg": "d8b4",
	"./apidays-live-hongkong/2022/speakers/jimmy-pro.jpg": "cf39",
	"./apidays-live-hongkong/2022/speakers/joey-pro.jpg": "6eb8",
	"./apidays-live-hongkong/2022/speakers/jonathan-pro.jpg": "835d",
	"./apidays-live-hongkong/2022/speakers/kenneth-pro.jpg": "4091",
	"./apidays-live-hongkong/2022/speakers/martin-pro.jpg": "8b6f",
	"./apidays-live-hongkong/2022/speakers/mary-pro.jpg": "4475",
	"./apidays-live-hongkong/2022/speakers/matt-pro.jpg": "0661",
	"./apidays-live-hongkong/2022/speakers/mehdi-pro.jpg": "53b9",
	"./apidays-live-hongkong/2022/speakers/michael-pro.jpg": "ac05",
	"./apidays-live-hongkong/2022/speakers/motti-pro.jpg": "5bc3",
	"./apidays-live-hongkong/2022/speakers/nelson-pro.jpg": "1539",
	"./apidays-live-hongkong/2022/speakers/nicolas-pro.jpg": "1b7f",
	"./apidays-live-hongkong/2022/speakers/patrick-pro.jpg": "4c8e",
	"./apidays-live-hongkong/2022/speakers/paul-pro.jpg": "1f07",
	"./apidays-live-hongkong/2022/speakers/ray-pro.jpg": "3805",
	"./apidays-live-hongkong/2022/speakers/richard-pro.jpg": "23ae",
	"./apidays-live-hongkong/2022/speakers/rob-pro.jpg": "1031",
	"./apidays-live-hongkong/2022/speakers/sanvy-pro.jpg": "a5d8",
	"./apidays-live-hongkong/2022/speakers/simon-pro.jpg": "4efd",
	"./apidays-live-hongkong/2022/speakers/sonal-pro.jpg": "9027",
	"./apidays-live-hongkong/2022/speakers/steve-pro.jpg": "f58e",
	"./apidays-live-hongkong/2022/speakers/steven-pro.jpg": "d8e0",
	"./apidays-live-hongkong/2022/speakers/sunny-pro.jpg": "d388",
	"./apidays-live-hongkong/2022/speakers/toa-pro.jpg": "1fd1",
	"./apidays-live-hongkong/2022/speakers/trevor-pro.jpg": "bff7",
	"./apidays-live-hongkong/2022/speakers/uli-pro.jpg": "7a68",
	"./apidays-live-hongkong/2022/speakers/wilson-pro.jpg": "de66",
	"./apidays-live-hongkong/2022/speakers/zhiyuan-pro.jpg": "9b31",
	"./apidays-live-hongkong/2022/sponsors/aws.png": "ffc1",
	"./apidays-live-hongkong/2022/sponsors/confluent.png": "5dc0",
	"./apidays-live-hongkong/2022/sponsors/hkcs.png": "af3d",
	"./apidays-live-hongkong/2022/sponsors/hkstpsaa.png": "f58ea",
	"./apidays-live-hongkong/2022/sponsors/new-relic.png": "e2fc",
	"./apidays-live-hongkong/2022/sponsors/openapihub.png": "ca48",
	"./apidays-live-hongkong/images/apidays-2020-facts.png": "2f9b",
	"./apidays-live-hongkong/images/apidays-HongKong-logowall.png": "dce6",
	"./apidays-live-hongkong/images/apidays-banner-light.jpg": "c68a",
	"./apidays-live-hongkong/images/apidays-banner.jpg": "9848",
	"./apidays-live-hongkong/images/apidays-live-hongkong-2020agenda.png": "c9a2",
	"./apidays-live-hongkong/images/apidays-onsite-1.jpg": "2102",
	"./apidays-live-hongkong/images/apidays-onsite-2.jpg": "e25e",
	"./apidays-live-hongkong/images/apidays-onsite-3.jpg": "c3f6",
	"./apidays-live-hongkong/images/apidays-ppt-1.png": "72c2",
	"./apidays-live-hongkong/images/apidays-ppt-2.png": "8c73",
	"./apidays-live-hongkong/images/apidays-ppt-3.png": "9c49",
	"./apidays-live-hongkong/images/apidays-ppt-4.png": "2969",
	"./apidays-live-hongkong/images/apidays-ppt-5.png": "3c06",
	"./apidays-live-hongkong/images/apidays.jpg": "c47d",
	"./apidays-live-hongkong/organisers/apidays-2022.png": "f318",
	"./apidays-live-hongkong/organisers/apidays-live-hk-color.png": "8fac",
	"./apidays-live-hongkong/organisers/apidays.png": "b8da",
	"./apidays-live-hongkong/organisers/benovelty.png": "f858",
	"./apidays-live-hongkong/organisers/hkstp.png": "dae5",
	"./apidays-live-hongkong/speakers/alan-pro.jpg": "7cec",
	"./apidays-live-hongkong/speakers/alan-smc.jpg": "30a6",
	"./apidays-live-hongkong/speakers/alex-pro.jpg": "2f83",
	"./apidays-live-hongkong/speakers/alex-smc.jpg": "c5af",
	"./apidays-live-hongkong/speakers/anna-pro.jpg": "6723",
	"./apidays-live-hongkong/speakers/anna-smc.jpg": "3077",
	"./apidays-live-hongkong/speakers/asanka-pro.jpg": "b954",
	"./apidays-live-hongkong/speakers/asanka-smc.jpg": "49b6",
	"./apidays-live-hongkong/speakers/atsushi-pro.jpg": "6d75",
	"./apidays-live-hongkong/speakers/atsushi-smc.jpg": "aa4a",
	"./apidays-live-hongkong/speakers/barry-pro.jpg": "7e45",
	"./apidays-live-hongkong/speakers/barry-smc.jpg": "f8f0",
	"./apidays-live-hongkong/speakers/ben-pro.jpg": "38d5",
	"./apidays-live-hongkong/speakers/ben-smc.jpg": "df7d",
	"./apidays-live-hongkong/speakers/daniele-pro.jpg": "119e",
	"./apidays-live-hongkong/speakers/daniele-smc.jpg": "cbc1",
	"./apidays-live-hongkong/speakers/david-pro.jpg": "b63e",
	"./apidays-live-hongkong/speakers/david-smc.jpg": "2277",
	"./apidays-live-hongkong/speakers/developersteve-pro.jpg": "bc27",
	"./apidays-live-hongkong/speakers/developersteve-smc.jpg": "f888",
	"./apidays-live-hongkong/speakers/donnie-pro.jpg": "7933",
	"./apidays-live-hongkong/speakers/donnie-smc.jpg": "419c",
	"./apidays-live-hongkong/speakers/forest-pro.jpg": "6366",
	"./apidays-live-hongkong/speakers/forest-smc.jpg": "5707",
	"./apidays-live-hongkong/speakers/fran-pro.jpg": "5569",
	"./apidays-live-hongkong/speakers/fran-smc.jpg": "24c2",
	"./apidays-live-hongkong/speakers/garry-pro.jpg": "aa2f",
	"./apidays-live-hongkong/speakers/garry-smc.jpg": "8b24",
	"./apidays-live-hongkong/speakers/greg-pro.jpg": "3539",
	"./apidays-live-hongkong/speakers/greg-smc.jpg": "0bb9",
	"./apidays-live-hongkong/speakers/helal-pro.jpg": "ff9a",
	"./apidays-live-hongkong/speakers/helal-smc.jpg": "63ff",
	"./apidays-live-hongkong/speakers/hieu-pro.jpg": "8065",
	"./apidays-live-hongkong/speakers/hieu-smc.jpg": "fd99",
	"./apidays-live-hongkong/speakers/hugo-pro.jpg": "a2ee",
	"./apidays-live-hongkong/speakers/hugo-smc.jpg": "6259",
	"./apidays-live-hongkong/speakers/ilona-pro.jpg": "fded",
	"./apidays-live-hongkong/speakers/ilona-smc.jpg": "1074",
	"./apidays-live-hongkong/speakers/img12.jpg": "6681",
	"./apidays-live-hongkong/speakers/jed-pro.jpg": "b05a",
	"./apidays-live-hongkong/speakers/jed-smc.jpg": "123e",
	"./apidays-live-hongkong/speakers/jenks-pro.jpg": "85c4",
	"./apidays-live-hongkong/speakers/jenks-smc.jpg": "6e42",
	"./apidays-live-hongkong/speakers/johan-pro.jpg": "c593",
	"./apidays-live-hongkong/speakers/johan-smc.jpg": "5341",
	"./apidays-live-hongkong/speakers/john-pro.jpg": "0717",
	"./apidays-live-hongkong/speakers/john-smc.jpg": "3686",
	"./apidays-live-hongkong/speakers/julian-pro.jpg": "bba8",
	"./apidays-live-hongkong/speakers/julian-smc.jpg": "e8ab",
	"./apidays-live-hongkong/speakers/maciej-pro.jpg": "0241",
	"./apidays-live-hongkong/speakers/maciej-smc.jpg": "b475",
	"./apidays-live-hongkong/speakers/marco-pro.jpg": "0481",
	"./apidays-live-hongkong/speakers/marco-smc.jpg": "f30d",
	"./apidays-live-hongkong/speakers/michelle-pro.jpg": "7711",
	"./apidays-live-hongkong/speakers/michelle-smc.jpg": "ea4c",
	"./apidays-live-hongkong/speakers/nicky-pro.jpg": "c015",
	"./apidays-live-hongkong/speakers/nicky-smc.jpg": "f282",
	"./apidays-live-hongkong/speakers/patrick-pro.jpg": "cd34",
	"./apidays-live-hongkong/speakers/patrick-smc.jpg": "8724",
	"./apidays-live-hongkong/speakers/paul-pro.jpg": "042f",
	"./apidays-live-hongkong/speakers/paul-smc.jpg": "3ab5",
	"./apidays-live-hongkong/speakers/phil-pro.jpg": "72ca",
	"./apidays-live-hongkong/speakers/phil-smc.jpg": "904d",
	"./apidays-live-hongkong/speakers/rajesh-pro.jpg": "7f7c",
	"./apidays-live-hongkong/speakers/rajesh-smc.jpg": "3509",
	"./apidays-live-hongkong/speakers/richard-pro.jpg": "11e7",
	"./apidays-live-hongkong/speakers/richard-smc.jpg": "e6cd",
	"./apidays-live-hongkong/speakers/rob-pro.jpg": "5eae",
	"./apidays-live-hongkong/speakers/rob-smc.jpg": "bd67",
	"./apidays-live-hongkong/speakers/samuel-pro.jpg": "4d53",
	"./apidays-live-hongkong/speakers/samuel-smc.jpg": "1d1c",
	"./apidays-live-hongkong/speakers/shahnawaz-pro.jpg": "ddce",
	"./apidays-live-hongkong/speakers/shahnawaz-smc.jpg": "59b2",
	"./apidays-live-hongkong/speakers/simon-pro.jpg": "cf61",
	"./apidays-live-hongkong/speakers/simon-smc.jpg": "0b4b",
	"./apidays-live-hongkong/speakers/stanley-pro.jpg": "7f2c",
	"./apidays-live-hongkong/speakers/stanley-smc.jpg": "e79d",
	"./apidays-live-hongkong/speakers/zeev-pro.jpg": "1730",
	"./apidays-live-hongkong/speakers/zeev-smc.jpg": "89f6",
	"./apidays-live-hongkong/sponsors/alibaba-cloud.png": "5a57",
	"./apidays-live-hongkong/sponsors/apisfirst.png": "8820",
	"./apidays-live-hongkong/sponsors/auth0.png": "519e",
	"./apidays-live-hongkong/sponsors/daops.png": "817c",
	"./apidays-live-hongkong/sponsors/forgerock.png": "dfbd",
	"./apidays-live-hongkong/sponsors/ibm.png": "d82fc",
	"./apidays-live-hongkong/sponsors/nginx.png": "bbd4",
	"./apidays-live-hongkong/sponsors/wia.png": "a9a2",
	"./apidays-live-hongkong/sponsors/wso2.png": "4b20",
	"./apiecobooster/images/apiecobooster.jpg": "5584",
	"./apiecobooster/images/coding-2.jpg": "84cd",
	"./apiecobooster/images/payment-1.jpg": "0a38",
	"./apiecobooster/organisers/benovelty.png": "e3b5",
	"./apiecobooster/organisers/hkstp.png": "8c8f",
	"./apiecobooster/organisers/hsbc-logo.png": "b188",
	"./apiecobooster/organisers/hsbc.png": "4998",
	"./community-gallery/apidays-1.jpg": "acf1",
	"./community-gallery/apidays-2.png": "c42a",
	"./community-gallery/apidays-3.png": "4a7e",
	"./community-gallery/apiecobooster-demoday-1.jpg": "9283",
	"./community-gallery/apiecobooster-demoday-2.jpg": "79b2",
	"./webinars/banners/20200317_open_API_technology_entrepreneurial_journey_sharing.jpg": "f27f",
	"./webinars/banners/20200514_api_trends_and_challenges.jpg": "2edd",
	"./webinars/banners/20200515_opportunity_for_education_industry_digital_transformation.jpg": "6adb",
	"./webinars/banners/20200623_benovelty_taptab_boutir.jpg": "50d1",
	"./webinars/banners/20200907_future_of_law_legal_innovations_in_action_today.jpg": "807b",
	"./webinars/banners/20200929_local_startup_experience_sharing.jpg": "e52f",
	"./webinars/banners/20201022_executive_seminar_technologies_in_finance.jpg": "afba",
	"./webinars/banners/20201102_driving_innovations_in_open_banking.jpg": "ebe4",
	"./webinars/banners/20201103_fintech_and_the_new_normal.jpg": "0868",
	"./webinars/banners/20201112_benovelty_onedegree_fiberapi.jpg": "ff94",
	"./webinars/banners/20210329_aws_techconnect_series.png": "a106",
	"./webinars/banners/20210812-benovelty-dbs-xero.jpg": "31a6",
	"./webinars/banners/20211021-benovelty-dbs-xero.jpg": "ab69",
	"./webinars/banners/20211029-local-startup-experience-sharing.jpg": "8045",
	"./webinars/banners/20211209-steps-to-build-your-successful-ecommerce-kingdom.jpg": "0fcb",
	"./webinars/gallery/20200515-1.jpg": "27ac",
	"./webinars/gallery/20200515-2.jpg": "fcdf",
	"./webinars/gallery/20200515-3.jpg": "e607",
	"./webinars/gallery/20200515-4.jpg": "9b40",
	"./webinars/gallery/20200623-1.jpg": "ce83",
	"./webinars/gallery/20200623-2.jpg": "178e",
	"./webinars/gallery/20200623-3.jpg": "c263",
	"./webinars/gallery/20200623-4.jpg": "e767",
	"./webinars/gallery/20201102-1.jpg": "7929",
	"./webinars/gallery/20201102-2.jpg": "b1b4",
	"./webinars/gallery/20201102-3.jpg": "ffc9",
	"./webinars/gallery/20201102-4.jpg": "9d18",
	"./webinars/gallery/20201112-1.jpg": "7dea",
	"./webinars/gallery/20201112-2.jpg": "13fe",
	"./webinars/gallery/20201112-3.jpg": "5542",
	"./webinars/gallery/20201112-4.jpg": "dcd1",
	"./webinars/organisers/aws.png": "b3bb",
	"./webinars/organisers/benovelty.png": "d40a",
	"./webinars/organisers/boutir.png": "8835",
	"./webinars/organisers/cfte.png": "667a",
	"./webinars/organisers/cyberport.png": "d44a",
	"./webinars/organisers/dbs.png": "2f5e",
	"./webinars/organisers/f5.png": "b359",
	"./webinars/organisers/fiberapi.png": "c721",
	"./webinars/organisers/hkqaa.png": "9ce2",
	"./webinars/organisers/hkstp.png": "433b",
	"./webinars/organisers/hong_kong_society_for_quality.png": "5af9",
	"./webinars/organisers/hsbc-logo.png": "2b53",
	"./webinars/organisers/hsbc.png": "3d9f",
	"./webinars/organisers/migather.png": "60ae",
	"./webinars/organisers/onedegree.png": "0db6",
	"./webinars/organisers/solution_forest.png": "c53d",
	"./webinars/organisers/taptab.png": "3fcc",
	"./webinars/organisers/the_law_society_of_hong_kong.png": "c8f7",
	"./webinars/organisers/ust_entrepreneurship_center.png": "f092",
	"./webinars/organisers/xero.png": "036e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f9a7";